module.exports = __webpack_public_path__ + "static/media/night_white.f3104078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/night_white.svg
// module id = 969
// module chunks = 0